module.exports = __webpack_public_path__ + "img/visa.868e1896.svg";